import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportPackage = ({ icon, title, features, responseTime }) => {
  return (
    <div className="p-6 md:p-8 bg-card border border-border rounded-2xl hover:border-primary/50 transition-all duration-300">
      <div className="flex items-start gap-4 mb-4 md:mb-6">
        <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-success/10 flex items-center justify-center">
          <Icon name={icon} size={24} color="var(--color-success)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-bold font-heading text-foreground mb-2">
            {title}
          </h3>
          <div className="flex items-center gap-2 text-xs md:text-sm text-success">
            <Icon name="Zap" size={14} />
            <span className="font-medium">{responseTime} response time</span>
          </div>
        </div>
      </div>
      <ul className="space-y-2 md:space-y-3">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <Icon 
              name="Check" 
              size={16} 
              color="var(--color-success)" 
              className="flex-shrink-0 mt-1" 
            />
            <span className="text-sm md:text-base text-muted-foreground">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SupportPackage;